export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";
import { resolveOAuthRedirectOrigin } from "@shared/oauthRedirect";

export const APP_TITLE = import.meta.env.VITE_APP_TITLE || "App";

export const APP_LOGO =
  import.meta.env.VITE_APP_LOGO ||
  "https://placehold.co/128x128/E1E7EF/1F2937?text=App";

// Generate login URL at runtime so redirect URI reflects the current origin.
export const getLoginUrl = () => {
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL;
  const appId = import.meta.env.VITE_APP_ID;
  // Route temporary development-preview sign-ins through the stable public
  // domain, where the authorization-code exchange can be completed.
  const redirectOrigin = resolveOAuthRedirectOrigin(window.location.origin);
  const redirectUri = `${redirectOrigin}/api/oauth/callback`;
  const state = btoa(redirectUri);

  const url = new URL(`${oauthPortalUrl}/app-auth`);
  url.searchParams.set("appId", appId);
  url.searchParams.set("redirectUri", redirectUri);
  url.searchParams.set("state", state);
  url.searchParams.set("type", "signIn");

  return url.toString();
};
